module.exports = __webpack_public_path__ + "images/330b15b7c5ebfb9701f6555bfe1d1b28.jpg";